angular.module('invoice')
    .constant('InvoiceSubcontractorStatementConst', {
        eventUpdate: 'invoice-subcontractor-statement.updated'
    })
    .factory('InvoiceSubcontractorStatement', function ($resource) {
        return $resource(
            '/crm/api/invoice/:invoiceId/subcontractor-statements/:statementId',
            {invoiceId: '@invoiceId', statementId: '@id'},
            {
                update: {method: 'PUT'},
                table: {
                    method: 'GET',
                    isArray: false,
                    url: '/crm/api/invoice-subcontractor-statement/table'
                },
                forAgreement: {
                    method: 'GET',
                    isArray: false,
                    url: '/crm/api/invoice-subcontractor-statement/agreement/:agreementId'
                }
            }
        )
    })
    .service('InvoiceSubcontractorStatementService', function (
        $rootScope,
        modals,
        InvoiceSubcontractorStatement,
        InvoiceSubcontractorStatementConst
    ) {
        this.edit = (invoice, statement) => modals.open(
            'app/invoice/subcontractor-statement/edit-modal.html',
            'InvoiceSubcontractorStatementEditController',
            {
                invoice: invoice,
                statement: statement ? angular.copy(statement) : {
                    statementDate: moment().format('YYYY-MM-DD'),
                    receiptDate: moment().format('YYYY-MM-DD'),
                    receiptForm: 'ELECTRONIC'
                }
            },
            {size: 'md'},
            '$ctrl'
        )

        this.show = statement => modals.open(
            'app/invoice/subcontractor-statement/show-modal.html',
            'InvoiceSubcontractorStatementShowController',
            angular.copy(statement),
            {size: 'md'},
            '$ctrl'
        )

        this.delete = (invoiceId, statement) => modals.confirmDelete(
            'wybrane oświadczenie',
            () => InvoiceSubcontractorStatement.delete({
                invoiceId: invoiceId,
                statementId: statement.id
            }).$promise.then(() => {
                $rootScope.$broadcast(InvoiceSubcontractorStatementConst.eventUpdate)
            })
        )
    })
    .controller('InvoiceSubcontractorStatementEditController', function (
        $rootScope,
        $uibModalInstance,
        toastr,
        data,
        InvoiceSubcontractorStatement,
        InvoiceSubcontractorStatementConst
    ) {
        this.$onInit = () => {
            this.invoice = data.invoice
            this.agreement = this.invoice.substantiveDescription
                ? this.invoice.substantiveDescription.agreement
                : null
            this.item = data.statement
        }

        this.isVatAmountEntered = () => this.item && this.item.vatAmount != null
        this.areAmountsIncomplete = () => this.isVatAmountEntered()
            && (this.item.netAmount == null || this.item.grossAmount == null)
        this.areAmountsInconsistent = () => {
            if (!this.isVatAmountEntered() || this.areAmountsIncomplete()) {
                return false
            }
            const toCents = amount => Math.round(Number(amount) * 100)
            return toCents(this.item.netAmount) + toCents(this.item.vatAmount) !== toCents(this.item.grossAmount)
        }
        this.areAmountsInvalid = () => this.areAmountsIncomplete() || this.areAmountsInconsistent()

        this.save = () => {
            const params = {
                invoiceId: this.invoice.id,
                statementId: this.item.id
            }
            const action = this.item.id
                ? InvoiceSubcontractorStatement.update(params, this.item).$promise
                : InvoiceSubcontractorStatement.save(params, this.item).$promise

            return action.then(result => {
                $rootScope.$broadcast(InvoiceSubcontractorStatementConst.eventUpdate)
                toastr.success('Zapisano oświadczenie')
                $uibModalInstance.close(result)
            })
        }

        this.cancel = () => $uibModalInstance.dismiss()
    })
    .controller('InvoiceSubcontractorStatementShowController', function (
        $uibModalInstance,
        data
    ) {
        this.$onInit = () => this.item = data
        this.cancel = () => $uibModalInstance.dismiss()
    })
    .component('invoiceSubcontractorStatementTable', {
        bindings: {
            items: '<',
            page: '<',
            showInvoice: '<',
            sortable: '<',
            editable: '<',
            onEdit: '&?',
            onDelete: '&?'
        },
        templateUrl: 'app/invoice/subcontractor-statement/table.html',
        controller: function (InvoiceSubcontractorStatementService) {
            const userIdentity = user => {
                if (!user) {
                    return null
                }
                return user.id != null ? 'id:' + user.id : 'name:' + user.fullName
            }
            const timestamp = value => value ? new Date(value).getTime() : null

            this.show = item => InvoiceSubcontractorStatementService.show(item)
            this.hasDistinctUpdate = item => {
                const audit = item && item.audit
                if (!audit || (!audit.updatedBy && !audit.updatedTime)) {
                    return false
                }
                return userIdentity(audit.updatedBy) !== userIdentity(audit.createdBy)
                    || timestamp(audit.updatedTime) !== timestamp(audit.createdTime)
            }
        }
    })
    .component('invoiceSubcontractorStatements', {
        bindings: {
            invoice: '<',
            onDataLoaded: '&?'
        },
        templateUrl: 'app/invoice/subcontractor-statement/invoice-tab.html',
        controller: function (
            $scope,
            InvoiceSubcontractorStatement,
            InvoiceSubcontractorStatementService,
            InvoiceSubcontractorStatementConst,
            Principal
        ) {
            this.$onChanges = () => {
                if (!this.invoice || !this.invoice.id) {
                    return
                }
                this.load()
                Principal.currentUser().then(user => {
                    const isWorker = this.invoice.worker && this.invoice.worker.id === user.id
                    const hasWriteRole = Principal.hasAnyAuthority([
                        'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_WRITE',
                        'ROLE_ADMIN'
                    ])
                    const canWriteWithReadAccess = Principal.hasAnyAuthority([
                        'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_WRITE_WITH_READ_ACCESS',
                        'ROLE_ADMIN'
                    ])
                    const canWriteInvoice = isWorker || Principal.hasAnyAuthority([
                        'ROLE_INVOICE_DOCUMENTS_ACCOUNTING',
                        'ROLE_INVOICE_DOCUMENTS_ALL',
                        'ROLE_ADMIN'
                    ])
                    this.editable = canWriteWithReadAccess || (hasWriteRole && canWriteInvoice)
                })
            }

            this.load = () => InvoiceSubcontractorStatement.query({
                invoiceId: this.invoice.id
            }).$promise.then(items => {
                this.items = items
                if (angular.isFunction(this.onDataLoaded)) {
                    this.onDataLoaded({$count: items.length})
                }
            })

            this.add = () => InvoiceSubcontractorStatementService.edit(this.invoice)
            this.edit = item => InvoiceSubcontractorStatementService.edit(this.invoice, item)
            this.delete = item => InvoiceSubcontractorStatementService.delete(this.invoice.id, item)

            $scope.$on(InvoiceSubcontractorStatementConst.eventUpdate, this.load)
        }
    })
    .component('agreementSubcontractorStatements', {
        bindings: {
            agreementId: '<',
            onDataLoaded: '&?'
        },
        templateUrl: 'app/invoice/subcontractor-statement/agreement-tab.html',
        controller: function (InvoiceSubcontractorStatement) {
            this.filters = {page: 1, size: 50}

            this.$onChanges = () => {
                if (!this.agreementId) {
                    return
                }
                this.load()
            }

            this.load = () => InvoiceSubcontractorStatement.forAgreement(angular.extend(
                {agreementId: this.agreementId},
                this.filters
            )).$promise.then(page => {
                this.page = page
                if (angular.isFunction(this.onDataLoaded)) {
                    this.onDataLoaded({$count: page.fullListSize})
                }
            })
        }
    })
    .component('invoiceSubcontractorStatementList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/invoice/subcontractor-statement/list.html',
        controller: function (Invoice) {
            this.$onInit = () => {
                this.receiptForms = ['ELECTRONIC', 'PAPER']
                Invoice.statuses().$promise.then(items => this.invoiceStatuses = items)
                Invoice.types().$promise.then(items => this.invoiceTypes = items)
            }

            this.reset = () => this.filters = {}
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('invoiceSubcontractorStatementList', {
            parent: 'app',
            url: '/invoice-subcontractor-statement?{page:int}&{size:int}&sort&search&subcontractor&agreementId&statementDateFrom&statementDateTo&receiptDateFrom&receiptDateTo&receiptForm&invoiceStatus&invoiceType&{netAmountFrom:number}&{netAmountTo:number}&{vatAmountFrom:number}&{vatAmountTo:number}&{grossAmountFrom:number}&{grossAmountTo:number}',
            data: {
                authorities: [
                    'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_READ',
                    'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_WRITE_WITH_READ_ACCESS',
                    'ROLE_ADMIN'
                ]
            },
            params: {
                receiptForm: {array: true, value: [], squash: false},
                invoiceStatus: {array: true, value: [], squash: false},
                invoiceType: {array: true, value: [], squash: false}
            },
            views: {
                'content@': 'invoiceSubcontractorStatementList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (InvoiceSubcontractorStatement, $stateParams) =>
                    InvoiceSubcontractorStatement.table(angular.copy($stateParams)).$promise
            }
        })
    })
